import { render, staticRenderFns } from "./CenteredText.vue?vue&type=template&id=729f8eb5&scoped=true&"
import script from "./CenteredText.vue?vue&type=script&lang=js&"
export * from "./CenteredText.vue?vue&type=script&lang=js&"
import style0 from "./CenteredText.vue?vue&type=style&index=0&id=729f8eb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729f8eb5",
  null
  
)

export default component.exports